// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"f5608e1c","295":"7166474c","483":"457afe6c","610":"79bb7ac9","813":"d56ac082"}[chunkId] + ".chunk.js";
};